import { render, staticRenderFns } from "./SalesReturnReports.vue?vue&type=template&id=056bc2da&"
import script from "./SalesReturnReports.vue?vue&type=script&lang=js&"
export * from "./SalesReturnReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports